import type { AssistantCommandView } from "@opus-dt/shared-types";
import { DisplayCard } from "./DisplayCard";
import { ActionCard } from "./ActionCard";
import { NavigateCard } from "./NavigateCard";

// Dispatcher do card por kind. DISPLAY auto-renderiza / NAVIGATE auto-abre a rota
// (canal 2 no cliente); ACTION passa pelo card de confirmação (exceto `safe`, que auto-confirma).
export function CommandCard({
  command,
  conversationId,
  live = false,
}: {
  command: AssistantCommandView;
  conversationId: string | null;
  live?: boolean; // true só p/ o comando do turno vivo (auto-navegação segura, sem replay)
}) {
  if (command.kind === "DISPLAY") return <DisplayCard command={command} />;
  if (command.kind === "NAVIGATE") return <NavigateCard command={command} live={live} />;
  return <ActionCard command={command} conversationId={conversationId} />;
}
